//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : cambio de talle de la ficha 

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Box,
  TextField,
  Autocomplete,
} from "@mui/material";
import Notify from "../../Notify";
import { getData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";
import moment from "moment";

function CambioTalle(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const style = { backgroundColor: "#ffffff", width: "100%" };
  const [renglones, setRenglones] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [almacenesDestino, setAlmacenesDestino] = useState({}); // Almacenes de destino seleccionados por renglón
  const [almacenesOrigen, setAlmacenesOrigen] = useState({}); // Almacenes de origen seleccionados por renglón
  const [inventariosGeneralesDestino, setInventariosGeneralesDestino] = useState({}); // Inventario general de destino por renglón
  const [inventariosGeneralesOrigen, setInventariosGeneralesOrigen] = useState({}); // Inventario general de origen por renglón
  const [inventariosPorTallesDestino, setInventariosPorTallesDestino] = useState({}); // Inventario por talles de destino por renglón
  const [inventariosPorTallesOrigen, setInventariosPorTallesOrigen] = useState({}); // Inventario por talles de origen por renglón
  const [tallesPorArticulo, setTallesPorArticulo] = useState({}); // Estado para almacenar talles por artículo
  const [tallesSeleccionados, setTallesSeleccionados] = useState({});
  const [habilitarGuardar, setHabilitarGuardar] = useState(false);
  const [notificacionDinamica, setNotificacionDinamica] = useState({
    open: false,
    mensaje: "",
    severity: "info",
  });
  const [erroresStock, setErroresStock] = useState({});
  const [renglonModificado, setRenglonModificado] = useState(null);
  const [renglonesModificados, setRenglonesModificados] = useState(new Set());

  // Obtener almacenes
  const obtenerAlmacenes = () => {
    getData("/stock_almacenes/xsucursal/" + props.location.id, setAlmacenes);
  };

  // Obtener renglones
  const obtenerRenglones = () => {
    getData(
      "/stock_ficha_renglon/renglonxficha/" + props.row.uuid_ficha,
      setRenglones
    );
  };

  // Obtener los talles por artículo
  const obtenerTalles = (idArticulo) => {
    getData("/stock_prendas_talles/tallesxarticulo/" + idArticulo, (data) => {
      setTallesPorArticulo((prev) => ({ ...prev, [idArticulo]: data }));
    });
  };

  // Obtener inventario general
  const obtenerInventarioGeneral = (
    renglonId,
    idAlmacen,
    idArticulo,
    setInventario
  ) => {
    if (!idAlmacen || !idArticulo) return;

    fetch(`${UrlApi}/stock_inventarios/xalmart/${idAlmacen}/${idArticulo}`)
      .then((res) => res.json())
      .then((data) =>
        setInventario((prev) => ({
          ...prev,
          [renglonId]: data, // Guardamos el inventario en el estado con el ID del renglón
        }))
      )
      .catch((error) =>
        console.error(
          `Error al obtener el inventario general (${renglonId}):`,
          error
        )
      );
  };

  // Obtener inventario por talles
  const obtenerInventarioPorTalles = (
    renglonId,
    idAlmacen,
    idArticulo,
    setInventario
  ) => {
    if (!idAlmacen || !idArticulo) return;

    getData(`/stock_prendas/detalle/${idAlmacen}/${idArticulo}`, (data) => {
      setInventario((prev) => ({
        ...prev,
        [renglonId]: data, // Guardamos el inventario por talles en el estado con el ID del renglón
      }));
    });
  };

  // Actualizar datos cuando los renglones o almacenes seleccionados cambian
  useEffect(() => {
    if (renglones.length > 0) {
      renglones.forEach((renglon) => {
        const idAlmacenDestino = almacenesDestino[renglon.id]?.id_almacen; // Almacén de destino seleccionado por renglón
        const idAlmacenOrigen = almacenesOrigen[renglon.id]?.id_almacen; // Almacén de origen seleccionado por renglón
        const idArticulo = renglon.id_articulo;

        // Obtener inventario general y por talles para el almacén de destino
        if (idAlmacenDestino && idArticulo) {
          obtenerInventarioGeneral(
            renglon.id,
            idAlmacenDestino,
            idArticulo,
            setInventariosGeneralesDestino
          );
          obtenerInventarioPorTalles(
            renglon.id,
            idAlmacenDestino,
            idArticulo,
            setInventariosPorTallesDestino
          );
        }

        // Obtener inventario general y por talles para el almacén de origen
        if (idAlmacenOrigen && idArticulo) {
          obtenerInventarioGeneral(
            renglon.id,
            idAlmacenOrigen,
            idArticulo,
            setInventariosGeneralesOrigen
          );
          obtenerInventarioPorTalles(
            renglon.id,
            idAlmacenOrigen,
            idArticulo,
            setInventariosPorTallesOrigen
          );
        }

        // Obtener talles para el artículo
        obtenerTalles(idArticulo);
      });
    }
  }, [renglones, almacenesDestino, almacenesOrigen]); // Se ejecuta cuando cambia la lista de renglones o los almacenes seleccionados

  // Cargar almacenes y renglones al inicio
  useEffect(() => {
    obtenerAlmacenes();
    obtenerRenglones();
  }, []);

  // Manejo de cierre del modal
  const handleClose = () => {
    props.onClose(false);
  };

  useEffect(() => {
    for (const renglon of renglones) {
      const inventarioGeneralOrigen = inventariosGeneralesOrigen[renglon.id];
      // console.log("renglon", inventarioGeneralOrigen);
    }
  }, [renglones, inventariosGeneralesOrigen]);

// deshabilitar boton
useEffect(() => {
  let nuevosErroresStock = {};
  let notificacion = null;

  const validarRenglon = (renglon) => {
    const idAlmacenOrigen = almacenesOrigen[renglon.id]?.id_almacen;
    const idAlmacenDestino = almacenesDestino[renglon.id]?.id_almacen;
    const talleSeleccionado = tallesSeleccionados[renglon.id];
    const tieneTalles = renglon.tiene_talles === 1;

    if (!idAlmacenOrigen || !idAlmacenDestino || (tieneTalles && !talleSeleccionado)) {
      notificacion = {
        open: true,
        mensaje: "Faltan selecciones en uno o más renglones.",
        severity: "warning",
      };
      return false;
    }

    if (tieneTalles) {
      const stockPorTallesOrigen = inventariosPorTallesOrigen[renglon.id];
      const talleSeleccionadoOrigen = stockPorTallesOrigen?.find(
        (item) => item.talle === talleSeleccionado.id
      );

      if (!talleSeleccionadoOrigen || talleSeleccionadoOrigen.cantidad < renglon.cantidad) {
        nuevosErroresStock[renglon.id] = "Stock insuficiente";
        notificacion = {
          open: true,
          mensaje: `Stock Insuficiente de ${renglon.nombre_articulo}.`,
          severity: "error",
        };
        return false;
      }
    } else {
      const inventarioGeneralOrigen = inventariosGeneralesOrigen[renglon.id];
      if (!inventarioGeneralOrigen || inventarioGeneralOrigen[0].cantidad < renglon.cantidad) {
        nuevosErroresStock[renglon.id] = "Stock insuficiente";
        notificacion = {
          open: true,
          mensaje: `Stock Insuficiente de ${renglon.nombre_articulo}.`,
          severity: "error",
        };
        return false;
      }
    }

    return true;
  };

  let todosRenglonesValidos;

  if (renglonModificado !== null) {
    // Validar solo el renglón modificado
    todosRenglonesValidos = validarRenglon(renglones.find(r => r.id === renglonModificado));
  } else {
    // Validar todos los renglones
    todosRenglonesValidos = renglones.every(validarRenglon);
  }

  setErroresStock(nuevosErroresStock);
  setHabilitarGuardar(todosRenglonesValidos);

  if (notificacion) {
    setNotificacionDinamica(notificacion);
  }
}, [
  renglones, almacenesOrigen, almacenesDestino, tallesSeleccionados,
  inventariosPorTallesOrigen, inventariosGeneralesOrigen, renglonModificado
]);



// Función para manejar el guardado de cambios
// Registrar transacción de BAJA en el origen
const registrarTransaccionBaja = async (idArticulo, idAlmacenOrigen, cantidadEnviada) => {
  const response = await fetch(UrlApi + "/stock_transacciones", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_accion: 159, // Acción de baja de stock
      id_articulo: idArticulo,
      almacen_origen: idAlmacenOrigen,
      cantidad_enviada: cantidadEnviada,
      fecha_transaccion: moment(new Date()).format("YYYY-MM-DD HH:mm"),
      detalle_transaccion: "Devolución de equipo por cambio de talle",
      usuario: localStorage.getItem("user"),
    }),
  });

  if (!response.ok) {
    throw new Error("Error al registrar la transacción de baja");
  }
};

// Registrar transacción de INGRESO en el destino
const registrarTransaccionIngreso = async (idArticulo, idAlmacenDestino, cantidadEnviada) => {
  const response = await fetch(UrlApi + "/stock_transacciones", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_accion: 158, // Acción de ingreso de stock
      id_articulo: idArticulo,
      almacen_destino: idAlmacenDestino,
      cantidad_recibida: cantidadEnviada,
      fecha_transaccion: moment(new Date()).format("YYYY-MM-DD HH:mm"),
      detalle_transaccion: "Ingreso de equipo por cambio de talle",
      usuario: localStorage.getItem("user"),
    }),
  });

  if (!response.ok) {
    throw new Error("Error al registrar la transacción de ingreso");
  }
};

// Actualizar inventario general en el ORIGEN
const actualizarInventarioOrigen = async (inventarioGeneralOrigen, cantidadEnviada) => {
  const nuevaCantidadOrigen = inventarioGeneralOrigen[0].cantidad - cantidadEnviada;
  const response = await fetch(
    `${UrlApi}/stock_inventarios/${inventarioGeneralOrigen[0].id_inventario}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cantidad: nuevaCantidadOrigen,
        usuario: localStorage.getItem("user"),
      }),
    }
  );

  if (!response.ok) {
    throw new Error("Error al actualizar el inventario general en el origen");
  }
};

// Actualizar inventario general en el DESTINO
const actualizarInventarioDestino = async (inventarioGeneralDestino, cantidadEnviada) => {
  const nuevaCantidadDestino = inventarioGeneralDestino[0].cantidad + cantidadEnviada;
  const response = await fetch(
    `${UrlApi}/stock_inventarios/${inventarioGeneralDestino[0].id_inventario}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cantidad: nuevaCantidadDestino,
        usuario: localStorage.getItem("user"),
      }),
    }
  );

  if (!response.ok) {
    throw new Error("Error al actualizar el inventario general en el destino");
  }
};

// Crear inventario general en el DESTINO (si no existe)
const crearInventarioDestino = async (idArticulo, idAlmacenDestino, cantidadEnviada) => {
  const response = await fetch(`${UrlApi}/stock_inventarios`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_articulo: idArticulo,
      id_almacen: idAlmacenDestino,
      cantidad: cantidadEnviada,
      usuario: localStorage.getItem("user"),
    }),
  });

  if (!response.ok) {
    throw new Error("Error al crear el inventario general en el destino");
  }
};

// Actualizar inventario por talles en el ORIGEN
const actualizarInventarioTallesOrigen = async (
  stockPorTallesOrigen,
  idAlmacenOrigen,
  idArticulo,
  cantidadEnviada,
  talleSeleccionado
) => {
  if (stockPorTallesOrigen) {
    const talleSeleccionadoOrigen = stockPorTallesOrigen.find(
      (item) => item.talle === talleSeleccionado.id // Talle original
    );
// console.log("talleSeleccionadoOrigen", talleSeleccionadoOrigen);

    if (talleSeleccionadoOrigen) {
      const nuevaCantidadOrigen = talleSeleccionadoOrigen.cantidad - cantidadEnviada;
      const response = await fetch(
        `${UrlApi}/stock_prendas/${talleSeleccionadoOrigen.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            almacen: idAlmacenOrigen,
            articulo: idArticulo,
            talle: talleSeleccionadoOrigen.talle, // Talle original
            cantidad: nuevaCantidadOrigen,
            usuario: localStorage.getItem("user"),
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar el inventario por talles en el origen");
      }
    }
  }
};

// Actualizar inventario por talles en el DESTINO
const actualizarInventarioTallesDestino = async (
  stockPorTallesDestino,
  idAlmacenDestino,
  idArticulo,
  talleSeleccionado,
  cantidadEnviada,
  renglon
) => {
  if (stockPorTallesDestino) {
    const talleExistenteDestino = stockPorTallesDestino.find(
      (item) => item.talle === renglon.talle // Nuevo talle seleccionado
    );

    if (talleExistenteDestino && talleExistenteDestino.cantidad !== undefined) {
      const nuevaCantidadDestino = talleExistenteDestino.cantidad + cantidadEnviada;
      const response = await fetch(
        `${UrlApi}/stock_prendas/${talleExistenteDestino.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            almacen: idAlmacenDestino,
            articulo: idArticulo,
            talle: talleExistenteDestino.talle, // Nuevo talle seleccionado
            cantidad: nuevaCantidadDestino,
            usuario: localStorage.getItem("user"),
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar el inventario por talles en el destino");
      }
    } else {
      // Si el talle no existe en el destino, crear un nuevo registro
      
      const response = await fetch(`${UrlApi}/stock_prendas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          almacen: idAlmacenDestino,
          articulo: idArticulo,
          talle: renglon.talle, // Nuevo talle seleccionado
          cantidad: cantidadEnviada,
          usuario: localStorage.getItem("user"),
        }),
      });

      if (!response.ok) {
        throw new Error("Error al crear el inventario por talles en el destino");
      }
    }
  }
};

const actualizarFicha = async (
  renglon,
  talleSeleccionado
) => {

  if (talleSeleccionado) {
  const response = await fetch(
    `${UrlApi}/stock_ficha_renglon/${renglon.id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        talle: talleSeleccionado.id,
      }),
    }
  );


  if (!response.ok) {
    throw new Error("error actualizacion de ficha");
  }
}
}

const handleGuardar = async () => {
  try {
    // Iterar sobre cada renglón para procesar la baja y suba de stock
    for (const renglon of renglones) {
      if (!renglonesModificados.has(renglon.id)) continue;
      
      const idArticulo = renglon.id_articulo;
      const idAlmacenOrigen = almacenesOrigen[renglon.id]?.id_almacen;
      const idAlmacenDestino = almacenesDestino[renglon.id]?.id_almacen;
      const cantidadEnviada = renglon.cantidad;
      const tieneTalles = renglon.tiene_talles === 1;
      const talleSeleccionado = tallesSeleccionados[renglon.id];

      // Verificar si se ha seleccionado un talle
      if (tieneTalles && !talleSeleccionado) {
        throw new Error("No se ha seleccionado un talle para este renglón.");
      }

      // 1. Registrar transacción de BAJA en el origen
      await registrarTransaccionBaja(idArticulo, idAlmacenOrigen, cantidadEnviada);

      // 2. Actualizar inventario general en el ORIGEN (si corresponde)
      const inventarioGeneralOrigen = inventariosGeneralesOrigen[renglon.id];
      if (idAlmacenOrigen !== idAlmacenDestino && inventarioGeneralOrigen) {
        await actualizarInventarioOrigen(inventarioGeneralOrigen, cantidadEnviada);
      }

      // 3. Registrar transacción de INGRESO en el destino
      await registrarTransaccionIngreso(idArticulo, idAlmacenDestino, cantidadEnviada);

      // 4. Actualizar inventario general en el DESTINO (si corresponde)
      const inventarioGeneralDestino = inventariosGeneralesDestino[renglon.id];
      if (idAlmacenOrigen !== idAlmacenDestino) {
        if (inventarioGeneralDestino && inventarioGeneralDestino.length > 0) {
          await actualizarInventarioDestino(inventarioGeneralDestino, cantidadEnviada);
        } else {
          await crearInventarioDestino(idArticulo, idAlmacenDestino, cantidadEnviada);
        }
      }

      // 5. Actualizar inventario por talles en el ORIGEN (si corresponde)
      if (tieneTalles) {
        const stockPorTallesOrigen = inventariosPorTallesOrigen[renglon.id];
        const talleSeleccionado = tallesSeleccionados[renglon.id]
        // console.log("stock por talles origen",stockPorTallesOrigen, "talleseleccionado"
        //   , talleSeleccionado, "idalmacenOrigen", idAlmacenOrigen, "cantidadEnviada",cantidadEnviada,"idArticulo",idArticulo);
        
        await actualizarInventarioTallesOrigen(
          stockPorTallesOrigen,
          idAlmacenOrigen,
          idArticulo,
          cantidadEnviada,
          talleSeleccionado
        );
      }

      // 6. Actualizar inventario por talles en el DESTINO (si corresponde)
      if (tieneTalles && talleSeleccionado) {
        const stockPorTallesDestino = inventariosPorTallesDestino[renglon.id];
        // const talleSeleccionado = tallesSeleccionados[renglon.id]
        // console.log("renglon destino", renglon, "stockPorTallesDestino", stockPorTallesDestino);
        
        await actualizarInventarioTallesDestino(
          stockPorTallesDestino,
          idAlmacenDestino,
          idArticulo,
          talleSeleccionado,
          cantidadEnviada,
          renglon
        );
      }

      if (tieneTalles && talleSeleccionado) {
      // console.log("stockPorTallesOrigenFicha",talleSeleccionado);
      await actualizarFicha(
        renglon,
        talleSeleccionado
      );
    }
    }

    // Notificar éxito
    setNotificacion({
      open: true,
      mensaje: "La operación se realizó correctamente",
      severity: "success",
      color: "#D4EFDF",
    });
  } catch (error) {
    console.error(error.message);
    // Notificar error
    setNotificacion({
      open: true,
      mensaje: "Error al realizar la operación",
      severity: "error",
      color: "#F1948A",
    });
  }
};


  return (
    <Dialog fullWidth open={props.open} onClose={handleClose} maxWidth="xl">
      {notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => props.onClose(false)}
          severity={notificacion.severity}
        />
      )}
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Typography fontSize={20} align="center" color="#ffffff">
            Cambio de Talle
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} justifyContent={"center"} display={"flex"}>
            <Typography variant="h5">
              Cambio de talle del equipo entregado a {props.row.nombre_empleado}{" "}
              {props.row.apellido_empleado}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center" mt={2}>
          {renglones.length > 0 ? (
            renglones.map((renglon, index) => (
              <Grid container spacing={1} key={index} alignItems="center">
                <Grid item xs={2} mb={3}>
                  <TextField
                    fullWidth
                    label="Artículo"
                    value={renglon.nombre_articulo}
                    variant="outlined"
                    size="small"
                    InputProps={{ readOnly: true }}
                    focused
                    error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                  />
                </Grid>
                <Grid item xs={2} mb={3}>
                  <TextField
                    fullWidth
                    label="Descripción"
                    value={renglon.descripcion_articulo}
                    variant="outlined"
                    size="small"
                    InputProps={{ readOnly: true }}
                    focused
                    error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                  />
                </Grid>
                <Grid item xs={1} mb={3}>
                  <TextField
                    fullWidth
                    label="Talle"
                    value={renglon.nombre_talle}
                    variant="outlined"
                    size="small"
                    InputProps={{ readOnly: true }}
                    focused
                    error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                  />
                </Grid>
                <Grid item xs={1} mb={3}>
                  <TextField
                    fullWidth
                    label="Cantidad"
                    value={renglon.cantidad}
                    variant="outlined"
                    size="small"
                    InputProps={{ readOnly: true }}
                    focused
                    error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                    
                  />
                </Grid>

                <Grid item xs={2.5} mb={3}>
                  <Autocomplete
                    disabled={!almacenes}
                    size="small"
                    focused
                    disableClearable
                    id="almacenDestino"
                    noOptionsText={"Almacén INEXISTENTE"}
                    options={almacenes}
                    autoHighlight
                    getOptionLabel={(almacen) =>
                      `${almacen.id_almacen} - ${almacen.nombre}`
                    }
                    onChange={(event, value) =>{
                      setAlmacenesDestino((prev) => ({
                        ...prev,
                        [renglon.id]: value,
                      }))
                      setRenglonesModificados((prev) => new Set(prev).add(renglon.id));
                      setRenglonModificado(renglon.id);
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        {option.id_almacen} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Devuelvo el anterior a"
                        error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1} mb={3}>
                  <Autocomplete
                    size="small"
                    disableClearable
                    id={`nuevoTalle-${renglon.id_articulo}`}
                    options={tallesPorArticulo[renglon.id_articulo] || []}
                    getOptionLabel={(option) => option.talle}
                    onChange={(event, value) => {
                      // Actualizar el estado de tallesSeleccionados
                      setTallesSeleccionados((prev) => ({
                        ...prev,
                        [renglon.id]: value, // Guardar el talle seleccionado para este renglón
                      }));
                      setRenglonesModificados((prev) => new Set(prev).add(renglon.id));
                      setRenglonModificado(renglon.id);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Nuevo Talle"
                        variant="outlined"
                        size="small"
                        focused
                        required
                        error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.5} mb={3}>
                  <Autocomplete
                    disabled={!almacenes}
                    size="small"
                    focused
                    disableClearable
                    id="almacenOrigen"
                    noOptionsText={"Almacén INEXISTENTE"}
                    options={almacenes}
                    autoHighlight
                    getOptionLabel={(almacen) =>
                      `${almacen.id_almacen} - ${almacen.nombre}`
                    }
                    onChange={(event, value) =>{
                      setAlmacenesOrigen((prev) => ({
                        ...prev,
                        [renglon.id]: value,
                      }))
                      setRenglonesModificados((prev) => new Set(prev).add(renglon.id));
                      setRenglonModificado(renglon.id);
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        {option.id_almacen} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Saco el nuevo de"
                        error={!!erroresStock[renglon.id]} // Si hay error, se activa el borde rojo
                        helperText={erroresStock[renglon.id] || ""} // Muestra el mensaje de error
                      />
                    )}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Typography
              variant="body1"
              color="text.secondary"
              align="center"
              sx={{ width: "100%" }}
            >
              No hay renglones disponibles
            </Typography>
          )}
        </Grid>
        <Grid container justifyContent="space-between" mt={2}>
          <Button color="error" variant="contained" onClick={handleClose}>
            Volver
          </Button>
          <Button
            type="submit"
            color="success"
            variant="contained"
            onClick={handleGuardar}
            disabled={!habilitarGuardar}
          >
            Guardar
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default CambioTalle;
